//#region IMPORT
import React, { useEffect } from 'react';
import {
  Stack as MuiStack,
  Card as MuiCard,
  Button as MuiButton,
  Box as MuiBox,
  Unstable_Grid2 as Grid,
  Stack,
  TextField,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  Chip,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Divider,
  Slide,
  IconButton,
  Tooltip,
  tooltipClasses,
  styled,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  Refresh as RefreshIcon,
  Copyright as CopyrightIcon,
} from '@mui/icons-material';
import Icon from '../../Assets/Icon/CustomIcons';
import {
  AuthButton,
  Button,
  DatePicker,
  Dialog,
  Combo,
  Checkbox,
  GroupCheckbox,
  Radio,
  FRadio,
} from '../../Components/MUIs';
import Split from 'react-split';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { AgGridReact } from 'ag-grid-react';
import Commons from '../../Services/Common/Common';
import { motion } from 'framer-motion';
import { resetAddButtonError } from '../../Reducer/StatusFlagsReducer';
import { useDispatch, useSelector } from 'react-redux';
// 필터관련 컴포넌트
import { GridFilterButton } from '../../Components/GridFilterButton';
import { doesRowPassGridColumnFilters } from '../../Components/GridFilterButton/gridFilterUtils';
import { pruneSelectionForNonDisplayedRows } from '../../Components/Ui/GridCheckBox/GridCheckBoxFunction';
import { GridFilterSummary } from '../../Components/GridFilterSummary';
//#endregion

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// 커스터마이징된 Tooltip 생성
const LargeTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4CAF50', // 본체 배경 초록
    color: '#fff',
    fontSize: '0.9rem',
    padding: theme.spacing(1),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4CAF50', // 꼬리도 동일 색으로!
  },
}));

function BusinessGridGridCommon({
  content,
  item = {},
  checkItems = [],
  flex = 0,
  /* Grid Props */
  // left side
  getRowId1,
  gridRef1,
  columnDefs1,
  rowData1,
  setSelectedRowData1,
  setChangedRowData1,
  editable1 = false,
  onSelectionChanged1,
  onCellValueChanged1,
  onCellClicked1,
  pagination1 = true,
  rowDragManaged1 = false,
  onRowDragEnd1,
  autoGroupColumnDef1 = {},
  title1 = '기본정보',
  leftSize = 50,
  suppressCellFocus1 = false,
  /** 좌측 그리드에 추가로 주입할 AgGridReact props */
  gridProps1 = {},
  // right side
  getRowId2,
  gridRef2,
  columnDefs2,
  rowData2,
  setSelectedRowData2,
  setChangedRowData2,
  editable2 = false,
  onSelectionChanged2,
  onCellValueChanged2,
  onCellClicked2,
  pagination2 = true,
  rowDragManaged2 = false,
  onRowDragEnd2,
  autoGroupColumnDef2 = {},
  title2 = '상세정보',
  rightSize = 50,
  suppressCellFocus2 = false,
  rightBottomContent,
  /** rightBottomContent가 있을 때 우측 상단(그리드) 높이 고정 (예: 240 또는 '35%') */
  rightTopFixedHeight,
  /** 우측 그리드를 쓰지 않고, 컨텐츠만 풀 높이로 표시 */
  rightContentOnly,

  /* Button Props */
  // left side
  buttonsSx1, // object
  searchClick1 = () => {},
  addClick1 = () => {},
  saveClick1 = () => {},
  deleteClick1 = () => {},
  printClick1 = () => {},
  fileUploadClick1 = () => {},
  fileDownloadClick1 = () => {},
  refreshClick1 = () => {},
  applyClick1 = () => {},
  applyCancleClick1 = () => {},
  copyClick1 = () => {},
  // right side
  buttonsSx2, // object
  searchClick2 = () => {},
  addClick2 = () => {},
  saveClick2 = () => {},
  deleteClick2 = () => {},
  printClick2 = () => {},
  fileUploadClick2 = () => {},
  fileDownloadClick2 = () => {},
  refreshClick2 = () => {},
  applyClick2 = () => {},
  applyCancleClick2 = () => {},
  copyClick2 = () => {},

  /* Stack Props */
  // left side
  searchYn1 = 'N', // string
  copyYn1 = 'N', // string
  addYn1 = 'Y', // string
  saveYn1 = 'N', // string
  deleteYn1 = 'Y', // string
  printYn1 = 'N', // string
  multiPrintYn1 = 'N', // string
  other1, // object
  printItem1 = [],
  fileUploadYn1 = 'N', // string
  fileDownloadYn1 = 'N', // string
  refreshYn1 = 'Y', // string
  applyYn1 = 'N', // string
  applyName1 = '', //string
  applyCancleName1 = '', //string
  // right side
  searchYn2 = 'N', // string
  copyYn2 = 'N', // string
  addYn2 = 'Y', // string
  saveYn2 = 'N', // string
  deleteYn2 = 'Y', // string
  printYn2 = 'N', // string
  multiPrintYn2 = 'N', // string
  other2, // object
  printItem2 = [],
  fileUploadYn2 = 'N', // string
  fileDownloadYn2 = 'N', // string
  refreshYn2 = 'Y', // string
  applyYn2 = 'N', // string
  applyName2 = '', //string
  applyCancleName2 = '', //string
}) {
  const isAddButtonError = useSelector(
    (state) => state.StatusFlags.isAddButtonError
  );

  // 필터관련 - Grid1
  const [gridApi1, setGridApi1] = React.useState(null);
  const [gridColumnApi1, setGridColumnApi1] = React.useState(null);
  const [selectedFilters1, setSelectedFilters1] = React.useState({});
  const [headerMap1, setHeaderMap1] = React.useState({});
  const [isFiltered1, setIsFiltered1] = React.useState(false);
  const selectedFiltersRef1 = React.useRef(selectedFilters1);

  // 필터관련 - Grid2
  const [gridApi2, setGridApi2] = React.useState(null);
  const [gridColumnApi2, setGridColumnApi2] = React.useState(null);
  const [selectedFilters2, setSelectedFilters2] = React.useState({});
  const [headerMap2, setHeaderMap2] = React.useState({});
  const [isFiltered2, setIsFiltered2] = React.useState(false);
  const selectedFiltersRef2 = React.useRef(selectedFilters2);

  useEffect(() => {
    selectedFiltersRef1.current = selectedFilters1;
    if (gridRef1?.current?.api) {
      gridRef1.current.api.onFilterChanged(); // 필터 적용
    }
  }, [selectedFilters1]);

  useEffect(() => {
    selectedFiltersRef2.current = selectedFilters2;
    if (gridRef2?.current?.api) {
      gridRef2.current.api.onFilterChanged(); // 필터 적용
    }
  }, [selectedFilters2]);

  const dispatch = useDispatch();
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const anchorRef1 = React.useRef(null);
  const anchorRef2 = React.useRef(null);
  const [dialogToggle1, setDialogToggle1] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });
  const [dialogToggle2, setDialogToggle2] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });
  useEffect(() => {
    if (isAddButtonError) {
      const timer = setTimeout(() => {
        dispatch(resetAddButtonError());
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [isAddButtonError]);
  const HandleToggle1 = () => {
    setOpen1((prevOpen) => !prevOpen);
  };
  const HandleToggle2 = () => {
    setOpen2((prevOpen) => !prevOpen);
  };
  const HandleClose1 = (event) => {
    if (anchorRef1.current && anchorRef1.current.contains(event.target)) {
      return;
    }

    setOpen1(false);
  };
  const HandleClose2 = (event) => {
    if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
      return;
    }

    setOpen2(false);
  };
  function HandleListKeyDown1(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen1(false);
    } else if (event.key === 'Escape') {
      setOpen1(false);
    }
  }
  function HandleListKeyDown2(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen2(false);
    } else if (event.key === 'Escape') {
      setOpen2(false);
    }
  }
  const gridOptions1 = {
    singleClickEdit: true,
    rowClassRules: {
      'new-row': (params) => params.data && params.data.newYn === 'Y', // params.data가 존재하는지 확인 후 처리
      'delete-row': (params) => params.data && params.data.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data && params.data.editYn === 'Y' && params.data.newYn !== 'Y',
    },
    isExternalFilterPresent: () => {
      const filters = selectedFiltersRef1.current || {};
      return Object.keys(filters).some(
        (field) => (filters[field] || []).length > 0
      );
    },
    doesExternalFilterPass(node) {
      if (node.data?.newYn === 'Y') return true;
      if (node.data?.deleteYn === 'Y') return true;

      // 선택된 필터 값으로 통과 여부 판단
      const filters = selectedFiltersRef1.current || {};
      return Object.keys(filters).every((field) => {
        const values = filters[field] || [];
        if (values.length === 0) return true;
        const api = gridRef1?.current?.api ?? gridApi1;
        return doesRowPassGridColumnFilters(
          { [field]: values },
          node.data,
          columnDefs1,
          api
        );
      });
    },
  };

  const gridOptions2 = {
    singleClickEdit: true,
    rowClassRules: {
      'new-row': (params) => params.data && params.data.newYn === 'Y', // params.data가 존재하는지 확인 후 처리
      'delete-row': (params) => params.data && params.data.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data && params.data.editYn === 'Y' && params.data.newYn !== 'Y',
    },
    isExternalFilterPresent: () => {
      const filters = selectedFiltersRef2.current || {};
      return Object.keys(filters).some(
        (field) => (filters[field] || []).length > 0
      );
    },
    doesExternalFilterPass(node) {
      if (node.data?.newYn === 'Y') return true;
      if (node.data?.deleteYn === 'Y') return true;

      // 선택된 필터 값으로 통과 여부 판단
      const filters = selectedFiltersRef2.current || {};
      return Object.keys(filters).every((field) => {
        const values = filters[field] || [];
        if (values.length === 0) return true;
        const api = gridRef2?.current?.api ?? gridApi2;
        return doesRowPassGridColumnFilters(
          { [field]: values },
          node.data,
          columnDefs2,
          api
        );
      });
    },
  };

  const LeftSideButtons = () => {
    return (
      <MuiCard
        sx={{
          flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          overflow: 'visible',
          ...buttonsSx1,
        }}
      >
        {/* 제목 + 필터 한 그룹 */}
        <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{
              fontSize: '1.05rem',
              fontWeight: 'bold',
              color: '#2CA900',
              mr: 1, // 오른쪽으로 16px 여백
            }}
          >
            {title1}
          </Typography>

          {gridRef1 && (
            <GridFilterButton
              gridRef={gridRef1}
              gridApi1={gridApi1}
              gridColumnApi={gridColumnApi1}
              rowData={rowData1}
              selectedFiltersRef={selectedFiltersRef1}
              selectedFilters={selectedFilters1}
              setSelectedFilters={setSelectedFilters1}
              setIsFiltered={setIsFiltered1}
              setHeaderMap={setHeaderMap1}
              headerMap={headerMap1}
            />
          )}
        </MuiBox>

        <MuiBox sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 1.3 }}>
          {/* other 버튼 스타일 sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }} */}
          {other1 && other1}
          {copyYn1 === 'Y' && (
            <LargeTooltip title="복사" arrow placement="top">
              <MuiButton
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={copyClick1}
              >
                <CopyrightIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
                복사
              </MuiButton>
            </LargeTooltip>
          )}
          {applyYn1 === 'Y' && !Commons.IsMobile() && (
            <>
              <MuiButton
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={applyClick1}
              >
                {applyName1}
              </MuiButton>
              <MuiButton
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={applyCancleClick1}
              >
                {applyCancleName1}
              </MuiButton>
            </>
          )}
          {searchYn1 === 'Y' && (
            <MuiButton
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={searchClick1}
            >
              <SearchIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              검색
            </MuiButton>
          )}
          {addYn1 === 'Y' && (
            <motion.div
              animate={isAddButtonError ? { y: [0, -20, 0, -10, 0] } : { y: 0 }}
              transition={
                isAddButtonError
                  ? {
                      duration: 0.6,
                      repeat: Infinity,
                      repeatDelay: 1,
                      ease: 'easeOut',
                    }
                  : { duration: 0 }
              }
            >
              <LargeTooltip title="추가" arrow placement="top">
                <IconButton
                  color="primary"
                  sx={{
                    border: 1,
                  }}
                  size={''}
                  variant="outlined"
                  onClick={() => {
                    dispatch(resetAddButtonError());
                    addClick1();
                  }}
                >
                  <AddIcon fontSize={''} style={{ margin: 0 }} />
                </IconButton>
              </LargeTooltip>
            </motion.div>
          )}
          {saveYn1 === 'Y' && !Commons.IsMobile() && (
            <MuiButton
              sx={{ color: '#2CA900', borderColor: '#2CA900' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={saveClick1}
            >
              <SaveIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              저장
            </MuiButton>
          )}
          {refreshYn1 === 'Y' && (
            <LargeTooltip title="검색" arrow placement="top">
              <IconButton
                color="secondary"
                sx={{
                  border: 1,
                }}
                size={''}
                variant="outlined"
                onClick={refreshClick1}
              >
                <RefreshIcon fontSize={''} style={{ margin: 0 }} />
              </IconButton>
            </LargeTooltip>
          )}
          {deleteYn1 === 'Y' && !Commons.IsMobile() && (
            <LargeTooltip title="삭제" arrow placement="top">
              <IconButton
                color="error"
                sx={{
                  // color: "#D32F2F",
                  // borderColor: "#D32F2F",
                  border: 1,
                }}
                size={''}
                variant="outlined"
                onClick={deleteClick1}
                // onClick={() => {
                //   setDialogToggle1({
                //     ...dialogToggle1,
                //     open: true,
                //     title: '삭제',
                //     content: [
                //       <MuiBox
                //         sx={{
                //           height: '100%',
                //           width: '400px',
                //         }}
                //       >
                //         <Typography>선택한 항목을 삭제하시겠습니까?</Typography>
                //       </MuiBox>,
                //     ],
                //   });
                // }}
              >
                <DeleteIcon fontSize={''} style={{ margin: 0 }} />
              </IconButton>
            </LargeTooltip>
          )}
          {printYn1 === 'Y' && multiPrintYn1 === 'Y' && !Commons.IsMobile() ? (
            <div>
              <MuiButton
                ref={anchorRef1}
                id="composition-button"
                aria-controls={open1 ? 'composition-menu' : undefined}
                aria-expanded={open1 ? 'true' : undefined}
                aria-haspopup="true"
                sx={{ color: '#9370DB', borderColor: '#9370DB' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={HandleToggle1}
              >
                <PrintIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
                인쇄
              </MuiButton>
              <Popper
                open={open1}
                anchorEl={anchorRef1.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                sx={{ zIndex: 1300 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom-start'
                          ? 'left top'
                          : 'left bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={HandleClose1}>
                        <MenuList
                          autoFocusItem={open1}
                          id="composition-menu"
                          aria-labelledby="composition-button"
                          onKeyDown={HandleListKeyDown1}
                        >
                          {printItem1.map((_item, _index) => {
                            return (
                              <>
                                <MenuItem
                                  key={_index}
                                  onClick={(e) => {
                                    _item.onClick();
                                    HandleClose1(e);
                                  }}
                                  sx={{ fontSize: '14px' }}
                                >
                                  {_item.name}
                                </MenuItem>
                                {_index < printItem1.length - 1 && <Divider />}
                              </>
                            );
                          })}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          ) : printYn1 === 'Y' && !Commons.IsMobile() ? (
            <MuiButton
              sx={{ color: '#9370DB', borderColor: '#9370DB' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={printClick1}
            >
              <PrintIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              인쇄
            </MuiButton>
          ) : (
            <></>
          )}
          {fileUploadYn1 === 'Y' && (
            <LargeTooltip title="엑셀업로드" arrow placement="top">
              <IconButton
                color="secondary"
                ref={anchorRef1}
                id="composition-button"
                aria-controls={open1 ? 'composition-menu' : undefined}
                aria-expanded={open1 ? 'true' : undefined}
                aria-haspopup="true"
                sx={{
                  border: 1,
                }}
                variant="outlined"
                onClick={fileUploadClick1}
              >
                <Icon.FolderUpload />
              </IconButton>
            </LargeTooltip>
          )}
          {fileDownloadYn1 === 'Y' && (
            <LargeTooltip title="엑셀다운로드" arrow placement="top">
              <IconButton
                color="success"
                sx={{
                  border: 1,
                }}
                variant="outlined"
                onClick={fileDownloadClick1}
              >
                <Icon.FolderDownload />
              </IconButton>
            </LargeTooltip>
          )}
          {!other1 &&
            copyYn1 === 'N' &&
            applyYn1 === 'N' &&
            searchYn1 === 'N' &&
            addYn1 === 'N' &&
            saveYn1 === 'N' &&
            deleteYn1 === 'N' &&
            printYn1 === 'N' &&
            fileUploadYn1 === 'N' &&
            fileDownloadYn1 === 'N' &&
            refreshYn1 === 'N' && (
              <MuiButton
                sx={{
                  opacity: 0, // 투명
                  pointerEvents: 'none', // 클릭 방지
                  borderColor: 'transparent',
                }}
                variant="outlined"
              >
                빈 버튼
              </MuiButton>
            )}
        </MuiBox>
      </MuiCard>
    );
  };

  const RightSideButtons = () => (
    <MuiCard
      sx={{
        flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 1,
        ...buttonsSx2,
      }}
    >
      {/* 제목 + 필터 한 그룹 */}
      <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          sx={{
            fontSize: '1.05rem',
            fontWeight: 'bold',
            color: '#2CA900',
            mr: 1, // 오른쪽으로 16px 여백
          }}
        >
          {title2}
        </Typography>

        {gridRef2 && (
          <GridFilterButton
            gridRef={gridRef2}
            gridApi={gridApi2}
            gridColumnApi={gridColumnApi2}
            rowData={rowData2}
            selectedFiltersRef={selectedFiltersRef2}
            selectedFilters={selectedFilters2}
            setSelectedFilters={setSelectedFilters2}
            setIsFiltered={setIsFiltered2}
            setHeaderMap={setHeaderMap2}
            headerMap={headerMap2}
          />
        )}
      </MuiBox>

      <MuiBox sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 1.3 }}>
        {/* other 버튼 스타일 sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }} */}
        {other2 && other2}
        {copyYn2 === 'Y' && (
          <LargeTooltip title="복사" arrow placement="top">
            <MuiButton
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={copyClick2}
            >
              <CopyrightIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              복사
            </MuiButton>
            +
          </LargeTooltip>
        )}
        {applyYn2 === 'Y' && !Commons.IsMobile() && (
          <>
            <MuiButton
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={applyClick2}
            >
              {applyName2}
            </MuiButton>
            <MuiButton
              sx={{ m: 1, color: '#2196F3', borderColor: '#2196F3' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={applyCancleClick2}
            >
              {applyCancleName2}
            </MuiButton>
          </>
        )}
        {searchYn2 === 'Y' && (
          <MuiButton
            sx={{ color: '#2196F3', borderColor: '#2196F3' }}
            size={Commons.IsMobile() ? 'small' : ''}
            variant="outlined"
            onClick={searchClick2}
          >
            <SearchIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
            검색
          </MuiButton>
        )}
        {addYn2 === 'Y' && (
          <motion.div
            animate={isAddButtonError ? { y: [0, -20, 0, -10, 0] } : { y: 0 }}
            transition={
              isAddButtonError
                ? {
                    duration: 0.6,
                    repeat: Infinity,
                    repeatDelay: 1,
                    ease: 'easeOut',
                  }
                : { duration: 0 }
            }
          >
            <LargeTooltip title="추가" arrow placement="top">
              <IconButton
                color="primary"
                sx={{
                  border: 1,
                }}
                size={''}
                variant="outlined"
                onClick={() => {
                  dispatch(resetAddButtonError());
                  addClick2();
                }}
              >
                <AddIcon fontSize={''} style={{ margin: 0 }} />
              </IconButton>
            </LargeTooltip>
          </motion.div>
        )}
        {saveYn2 === 'Y' && !Commons.IsMobile() && (
          <MuiButton
            sx={{ color: '#2CA900', borderColor: '#2CA900' }}
            size={Commons.IsMobile() ? 'small' : ''}
            variant="outlined"
            onClick={saveClick2}
          >
            <SaveIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
            저장
          </MuiButton>
        )}
        {refreshYn2 === 'Y' && (
          <LargeTooltip title="검색" arrow placement="top">
            <IconButton
              color="secondary"
              sx={{
                border: 1,
              }}
              size={''}
              variant="outlined"
              onClick={refreshClick2}
            >
              <RefreshIcon fontSize={''} style={{ margin: 0 }} />
            </IconButton>
          </LargeTooltip>
        )}
        {deleteYn2 === 'Y' && !Commons.IsMobile() && (
          <LargeTooltip title="삭제" arrow placement="top">
            <IconButton
              color="error"
              sx={{
                // color: "#D32F2F",
                // borderColor: "#D32F2F",
                border: 1,
              }}
              size={''}
              variant="outlined"
              onClick={deleteClick2}
              // onClick={() => {
              //   setDialogToggle2({
              //     ...dialogToggle2,
              //     open: true,
              //     title: '삭제',
              //     content: [
              //       <MuiBox
              //         sx={{
              //           height: '100%',
              //           width: '400px',
              //         }}
              //       >
              //         <Typography>선택한 항목을 삭제하시겠습니까?</Typography>
              //       </MuiBox>,
              //     ],
              //   });
              // }}
            >
              <DeleteIcon fontSize={''} style={{ margin: 0 }} />
            </IconButton>
          </LargeTooltip>
        )}
        {printYn2 === 'Y' && multiPrintYn2 === 'Y' && !Commons.IsMobile() ? (
          <div>
            <MuiButton
              ref={anchorRef2}
              id="composition-button"
              aria-controls={open2 ? 'composition-menu' : undefined}
              aria-expanded={open2 ? 'true' : undefined}
              aria-haspopup="true"
              sx={{ color: '#9370DB', borderColor: '#9370DB' }}
              size={Commons.IsMobile() ? 'small' : ''}
              variant="outlined"
              onClick={HandleToggle2}
            >
              <PrintIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
              인쇄
            </MuiButton>
            <Popper
              open={open2}
              anchorEl={anchorRef2.current}
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
              sx={{ zIndex: 1300 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={HandleClose2}>
                      <MenuList
                        autoFocusItem={open2}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={HandleListKeyDown2}
                      >
                        {printItem2.map((_item, _index) => {
                          return (
                            <>
                              <MenuItem
                                key={_index}
                                onClick={(e) => {
                                  _item.onClick();
                                  HandleClose2(e);
                                }}
                                sx={{ fontSize: '14px' }}
                              >
                                {_item.name}
                              </MenuItem>
                              {_index < printItem2.length - 1 && <Divider />}
                            </>
                          );
                        })}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        ) : printYn2 === 'Y' && !Commons.IsMobile() ? (
          <MuiButton
            sx={{ color: '#9370DB', borderColor: '#9370DB' }}
            size={Commons.IsMobile() ? 'small' : ''}
            variant="outlined"
            onClick={printClick2}
          >
            <PrintIcon fontSize={Commons.IsMobile() ? 'small' : ''} />
            인쇄
          </MuiButton>
        ) : (
          <></>
        )}
        {fileUploadYn2 === 'Y' && (
          <LargeTooltip title="엑셀업로드" arrow placement="top">
            <IconButton
              color="secondary"
              ref={anchorRef2}
              id="composition-button"
              aria-controls={open2 ? 'composition-menu' : undefined}
              aria-expanded={open2 ? 'true' : undefined}
              aria-haspopup="true"
              sx={{
                border: 1,
              }}
              variant="outlined"
              onClick={fileUploadClick2}
            >
              <Icon.FolderUpload />
            </IconButton>
          </LargeTooltip>
        )}
        {fileDownloadYn2 === 'Y' && (
          <LargeTooltip title="엑셀다운로드" arrow placement="top">
            <IconButton
              color="success"
              sx={{
                border: 1,
              }}
              variant="outlined"
              onClick={fileDownloadClick2}
            >
              <Icon.FolderDownload />
            </IconButton>
          </LargeTooltip>
        )}
        {!other2 &&
          copyYn2 === 'N' &&
          applyYn2 === 'N' &&
          searchYn2 === 'N' &&
          addYn2 === 'N' &&
          saveYn2 === 'N' &&
          deleteYn2 === 'N' &&
          printYn2 === 'N' &&
          fileUploadYn2 === 'N' &&
          fileDownloadYn2 === 'N' &&
          refreshYn2 === 'N' && (
            <MuiButton
              sx={{
                opacity: 0, // 투명
                pointerEvents: 'none', // 클릭 방지
                borderColor: 'transparent',
              }}
              variant="outlined"
            >
              빈 버튼
            </MuiButton>
          )}
      </MuiBox>
    </MuiCard>
  );

  return (
    <Box sx={{ height: '100%', pt: 1 }}>
      <Split
        sizes={[leftSize, rightSize]} // 초기 비율
        minSize={150} // 최소 크기
        expandToMin={false} // 최소 크기보다 작아지지 않도록 설정
        gutterSize={10} // 드래그 바 크기
        gutterAlign="center"
        cursor="col-resize"
        className="split-container"
      >
        {/* 왼쪽 영역 */}
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            borderColor: 'divider',
            borderRadius: '10px',
            p: 2,
            pt: 1,
            backgroundColor: '#FFF',
          }}
        >
          {LeftSideButtons()}
          {/* 필터 요약 바 */}
          {gridRef1 && (
            <GridFilterSummary
              isFiltered={isFiltered1}
              selectedFilters={selectedFilters1}
              headerMap={headerMap1}
              setSelectedFilters={setSelectedFilters1}
            />
          )}
          <AgGridReact
            getRowId={getRowId1}
            ref={gridRef1}
            onGridReady={(params) => {
              setGridApi1(params.api);
              setGridColumnApi1(params.columnApi);
            }}
            animationRows={true}
            columnDefs={columnDefs1}
            rowData={rowData1}
            {...gridProps1}
            defaultColDef={{
              cellDataType: false,
              minWidth: 100,
              editable: editable1,
              resizable: true,
              sortable: true,
              filter: true,
              // floatingFilter: true,
            }}
            gridOptions={gridOptions1}
            stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
            rowSelection="multiple"
            // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
            onSelectionChanged={() => {
              const api = gridRef1?.current?.api ?? gridApi1;
              if (api) pruneSelectionForNonDisplayedRows(api);

              if (onSelectionChanged1) {
                onSelectionChanged1(gridRef1);
              } else {
                GridFunctions.onSelectionChanged(gridRef1, (_selected) => {
                  setSelectedRowData1(_selected);
                });
              }
            }}
            autoGroupColumnDef={autoGroupColumnDef1}
            groupDefaultExpanded={1} // 그룹 펼치기
            onCellValueChanged={(e) => {
              if (onCellValueChanged1) {
                onCellValueChanged1(e, gridRef1);
              } else {
                GridFunctions.onCellValueChanged(
                  e,
                  gridRef1,
                  setChangedRowData1
                );
              }
            }}
            onCellClicked={onCellClicked1}
            rowDragManaged={rowDragManaged1} // Drag True/False
            onRowDragEnd={onRowDragEnd1} // Drag End Event
            suppressCellFocus={suppressCellFocus1}
            pagination={pagination1} // enable pagination
            paginationPageSize={100} // sets 10 rows per page (default is 100)
            paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
            localeText={{
              // 기본 텍스트
              page: '페이지',
              more: '더보기',
              to: '~',
              of: '/',
              next: '다음',
              last: '마지막',
              first: '처음',
              previous: '이전',
              loadingOoo: '불러오는 중...',

              // 필터 & 패널 등
              selectAll: '전체 선택',
              searchOoo: '검색...',
              blanks: '공백',

              // 페이지 사이즈 선택기
              pageSizeSelectorLabel: '페이지 당 행 수',

              // 기본 페이지네이션 설명
              paginationPageSize: '페이지 당 행 수',
              paginationNumberFormatter: (params) => `${params.value}`,
            }}
          />
        </Box>
        {/* 오른쪽 영역 */}
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            p: 2,
            pt: 1,
            backgroundColor: '#FFF',
          }}
        >
          {rightContentOnly ? (
            <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
              {rightContentOnly}
            </Box>
          ) : (
            <>
              {RightSideButtons()}
              {/* 필터 요약 바 */}
              {gridRef2 && (
                <GridFilterSummary
                  isFiltered={isFiltered2}
                  selectedFilters={selectedFilters2}
                  headerMap={headerMap2}
                  setSelectedFilters={setSelectedFilters2}
                />
              )}
              <Box
                sx={{
                  minHeight: 0,
                  ...(rightBottomContent
                    ? {
                        height: rightTopFixedHeight ?? 260,
                        flexShrink: 0,
                      }
                    : {
                        flex: 1,
                      }),
                }}
              >
                <AgGridReact
                  getRowId={getRowId2}
                  ref={gridRef2}
                  onGridReady={(params) => {
                    setGridApi2(params.api);
                    setGridColumnApi2(params.columnApi);
                  }}
                  animationRows={true}
                  columnDefs={columnDefs2}
                  rowData={rowData2}
                  defaultColDef={{
                    cellDataType: false,
                    flex: flex,
                    minWidth: 100,
                    editable: editable2,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    // floatingFilter: true,
                  }}
                  gridOptions={gridOptions2}
                  stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
                  rowSelection="multiple"
                  // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                  onSelectionChanged={() => {
                    const api = gridRef2?.current?.api ?? gridApi2;
                    if (api) pruneSelectionForNonDisplayedRows(api);

                    if (onSelectionChanged2) {
                      onSelectionChanged2(gridRef2);
                    } else {
                      GridFunctions.onSelectionChanged(gridRef2, (_selected) => {
                        setSelectedRowData2(_selected);
                      });
                    }
                  }}
                  autoGroupColumnDef={autoGroupColumnDef2}
                  groupDefaultExpanded={1} // 그룹 펼치기
                  onCellValueChanged={(e) => {
                    if (onCellValueChanged2) {
                      onCellValueChanged2(e, gridRef2);
                    } else {
                      GridFunctions.onCellValueChanged(
                        e,
                        gridRef2,
                        setChangedRowData2
                      );
                    }
                  }}
                  onCellClicked={onCellClicked2}
                  rowDragManaged={rowDragManaged2} // Drag True/False
                  onRowDragEnd={onRowDragEnd2} // Drag End Event
                  suppressCellFocus={suppressCellFocus2}
                  pagination={pagination2} // enable pagination
                  paginationPageSize={100} // sets 10 rows per page (default is 100)
                  paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
                  localeText={{
                    // 기본 텍스트
                    page: '페이지',
                    more: '더보기',
                    to: '~',
                    of: '/',
                    next: '다음',
                    last: '마지막',
                    first: '처음',
                    previous: '이전',
                    loadingOoo: '불러오는 중...',

                    // 필터 & 패널 등
                    selectAll: '전체 선택',
                    searchOoo: '검색...',
                    blanks: '공백',

                    // 페이지 사이즈 선택기
                    pageSizeSelectorLabel: '페이지 당 행 수',

                    // 기본 페이지네이션 설명
                    paginationPageSize: '페이지 당 행 수',
                    paginationNumberFormatter: (params) => `${params.value}`,
                  }}
                />
              </Box>

              {rightBottomContent && (
                <Box
                  sx={{
                    mt: 1,
                    pt: 1,
                    borderTop: '1px solid #f0f2f4',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                  }}
                >
                  {rightBottomContent}
                </Box>
              )}
            </>
          )}
        </Box>
      </Split>
      {/* <Dialog
        sx={{ height: '100%' }}
        open={dialogToggle1.open}
        onClose={() => setDialogToggle1(false)}
        TransitionComponent={Transition}
        title={dialogToggle1.title}
        content={dialogToggle1.content}
        contentText={dialogToggle1.contentText}
        actions={dialogToggle1.actions}
        useSaveButton={true}
        useCloseButton={true}
        saveButtonName={'삭제'}
        closeButtonName={'닫기'}
        onSave={deleteClick1}
      />
      <Dialog
        sx={{ height: '100%' }}
        open={dialogToggle2.open}
        onClose={() => setDialogToggle2(false)}
        TransitionComponent={Transition}
        title={dialogToggle2.title}
        content={dialogToggle2.content}
        contentText={dialogToggle2.contentText}
        actions={dialogToggle2.actions}
        useSaveButton={true}
        useCloseButton={true}
        saveButtonName={'삭제'}
        closeButtonName={'닫기'}
        onSave={deleteClick2}
      /> */}
    </Box>
  );
}

export default BusinessGridGridCommon;
